import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from 'assets/js/auth';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken() || '',
    portfolioInfo: getUserInfo() || null
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, portfolioInfo) => {
      state.portfolioInfo = portfolioInfo;
    }
  },
  actions: {
    SET_LOGOUT({ commit }) {
      removeToken();
      removeUserInfo();
      commit('SET_TOKEN', null);
      commit('SET_USERINFO', null);
    },
    setToken({ commit }, token) {
      setToken(token);
      commit('SET_TOKEN', token);
    },
    setUserInfo({ commit }, info) {
      setUserInfo(info);
      commit('SET_USERINFO', info);
    },
  },
  modules: {
  },
  getters: {
    token: state => state.token,
    portfolioInfo: state => state.portfolioInfo,
  }
})
